import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

const updateItem = async ({ PK, SK, tableName, fieldName, newValue }) => {
  console.log('[UpdateItem] called with item: ', { PK, SK, tableName, fieldName, newValue })
  // const url = `${baseUrl}/aws/tasks/updateitems`
  const url = `${baseUrl}/aws/update`
  try {
    const response = await axios.put(url, { PK, SK, tableName, fieldName, newValue })
    if (response.status !== 200) throw new Error('Network response was not ok')
    return response.data
  } catch (error) {
    console.error('Failed to update item:', error)
    throw error
  }
}

export const useUpdateItem = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: updateItem,
    onSuccess: (data, variables) => {
      console.log('[useUpdateItem] Updated item data:', data, 'VARIABLES: ', variables)
      // queryClient.invalidateQueries({ queryKey: ['awsItems', variables.itemId] })
    },
    onError: error => {
      console.error('[useUpdateItem] Error updating item:', error)
    },
  })
  return mutation
}
